import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService, IAslibModalOptions } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';
import { AslibLoadingService } from '@aslib/loading';
import { ShowFile } from '../../shared/helpers/show-file';
import { Messages } from '../../shared/helpers/mensages';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import {
  AslibDualListComponent,
  AslibDualistAction,
  AslibFilterCallback,
  TransferCallback
} from "@aslib/dual-list";
import { AslibGridComponent, AslibTitleService } from '@aslib/components';
import { MunicipiosAptosService } from '../shared/service/municipios-aptos.service';
import { forEach } from '@angular/router/src/utils/collection';
import { CadastraMuncicipiosAptos, MunicipiosAptos } from '../shared/model/municipios-aptos.model';
import { BaseConfig } from '../../shared/service/base-config.service';


@Component({
  selector: 'sarf-cadastro-municipios-aptos',
  templateUrl: './cadastra-municipios-aptos.component.html'
})


export class CadastroMunicipiosAptos implements OnInit {
 @ViewChild('grid') grid: AslibGridComponent;

  usuarioLogado: any;
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;
  DataInicio: Date;
  formMunicipiosAptos: FormGroup;
  showFile: ShowFile;
  exibirCxMunicipios:boolean = true;
  listaMunicipios: any[];
  municipiosVig: any[] = [];
  msgDtinicioInvalida: string = "";
  dadosMunicipiosAptos: CadastraMuncicipiosAptos[]= [] ;

  duallist:AslibDualListComponent;
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent; 

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    protected readonly aslibModalService: AslibModalService,
    private aslibTitleService: AslibTitleService,
    private readonly municipiosAptosService: MunicipiosAptosService,
    private cd: ChangeDetectorRef,
    private baseConfig: BaseConfig
  ) {
    modalManagerHelper.parent = this;
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
    this.usuarioLogado = this.baseConfig.getUsuarioLogado();

  }


  ngOnInit() {
    this.listaMunicipios=[];

    this.formMunicipiosAptos = new FormGroup({
          municipios: new FormControl()
        });

  this.dadosOnInitFormulario(this.modalMensagem);
  }

  dadosOnInitFormulario(modal: AslibModalComponent){
    this.observerOnIniftFormulario = this.municipiosAptosService.dadosOnInitCadastro().subscribe(
      retornoRequest => {
        
         this.municipiosVig = [...retornoRequest.ListaMuncicipiosRoyalty];
         
        if(retornoRequest.objetoMensagem &&  
          retornoRequest.objetoMensagem.Mensagem !== null &&  
          retornoRequest.objetoMensagem.Mensagem !== '') {
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
        }

      },
      () => this.observerOnIniftFormulario.unsubscribe()
    );
  }

  ngAfterViewInit() {
  setTimeout(() => {
    this.aslibTitleService.Text = "Municípios Aptos";
    this.aslibTitleService.SubText = "Cadastrar"
    this.cd.detectChanges(); 
  });
}

limpar() {
  this.dadosOnInitFormulario(this.modalMensagem);
  this.listaMunicipios=[];
}

adicionar() {
  var muncSelecionados = this.formMunicipiosAptos.value.municipios;
  muncSelecionados.forEach(element => {
    
    const novo = {
      ...element,
      dtIni: null,
      dtFim: null,
      obs: ''
    };
    this.listaMunicipios.push(novo);
    this.listaMunicipios = [...this.listaMunicipios];
  });

}

salvarDados(grid: AslibGridComponent) {
if(!this.validaDataIncial(this.listaMunicipios)){
  new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: this.msgDtinicioInvalida,
        type: 'Info',
        windowClass: 'modalAlterado',
      }
    );
  return;
}
if(!this.validarDtiniDtFim(this.listaMunicipios)){
  new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: this.msgDtinicioInvalida,
        type: 'Info',
        windowClass: 'modalAlterado',
      }
    );
  return;
}

console.log('Dados salvos:', this.listaMunicipios);
this.setaDados(this.listaMunicipios);
this.registrarMunicipiosAptos();

}

  registrarMunicipiosAptos() {
    
    this._aslibLoadingService.start();
      this.subscription =  this.municipiosAptosService
        .registrarMunicipiosAptos(this.dadosMunicipiosAptos)
        .subscribe(          
          data => {
            if(data.Data){
              this.exibirSucesso(data.Message);
              this.limpar();
              this.irPraConsulta();
            }else{
              this.exibirError(data.Message);
            }        
          },
          (error: any) => {
            this.exibirError(error.Message);
            
          },
          () => {
            this.unSubscribe(); 
          }
        );
  }



/** Converte 'MM/YYYY' para [primeiroDiaDoMes, ultimoDiaDoMes] (Date locais, 00:00).
 *  Se 'mmyyyyFim' for nulo/undefined/string vazia, retorna end = null.
 */
monthRangeFromMmYyyy(
  mmyyyyIni: string,
  mmyyyyFim?: string | null
): { start: Date; end: Date | null; validacao: boolean } {

  // Aceita 'MM/YYYY' (com zero); troque por /^(0?[1-9]|1[0-2])\/(\d{4})$/ se quiser aceitar 'M/YYYY'
  var mmYyyyRegex = /^(0[1-9]|1[0-2])\/(\d{4})$/;

  // Normaliza entrada sem usar optional chaining
  var iniStr = (mmyyyyIni ? String(mmyyyyIni) : '').trim();
  var mIni = mmYyyyRegex.exec(iniStr);

  if (!mIni) {
   // this.exibirError("Formato inválido. Use 'MM/YYYY'. Valor recebido: '" + mmyyyyIni + "'");
    // Você pode lançar erro ou retornar algo padrão; aqui retorno um start inválido para sinalizar
    return { start: new Date(NaN), end: null, validacao: false };
  }

  var monthIni = parseInt(mIni[1], 10); // 01..12
  var yearIni  = parseInt(mIni[2], 10); // 4 dígitos

  // Início do mês (00:00 local)
  var start = new Date(yearIni, monthIni - 1, 1);

  // Se não houver fim informado (null/undefined/string vazia), retorna end = null
  if (mmyyyyFim == null || String(mmyyyyFim).trim() === '') {
    return { start: start, end: null, validacao: true };
  }

  var fimStr = String(mmyyyyFim).trim();
  var mFim = mmYyyyRegex.exec(fimStr);

  if (!mFim) {
    //this.exibirError("Formato inválido. Use 'MM/YYYY'. Valor recebido: '" + mmyyyyFim + "'");
    return { start: start, end: new Date(NaN), validacao: false };
  }

  var monthFim = parseInt(mFim[1], 10); // 01..12
  var yearFim  = parseInt(mFim[2], 10); // 4 dígitos

  // Último dia do mês (local): dia 0 do mês seguinte
  const end = new Date(yearFim, monthFim, 0);

  return { start, end, validacao: true };
}


  setaDados(listaMunicipios:any[]){
    this.dadosMunicipiosAptos = [];
    listaMunicipios.forEach(element => {
        const { start: mesInicio, end: mesFim } = this.monthRangeFromMmYyyy(element.dtIni, element.dtFim);
        const mesInicioTime = mesInicio.getTime();
        const mesFimTime = mesFim ? mesFim.getTime() : null;

      this.dadosMunicipiosAptos.push({
        SiglaUnidadeFederacao: element.SigUnidadeFederacao,
        CodigoMunicipio: element.IdMunicipio,
        DataInicioVigencia: mesInicio,
        DataFimVigencia: mesFim,
        DescricaoObservacao: element.obs,
        LoginUsuario: this.usuarioLogado.Login
      });
    });
  }
  exibirSucesso(mensagem:string){
              
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: mensagem,
        type: 'info'
      }
    );
  } 

  exibirError(mensagem:string){
               
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: mensagem,
        type: 'Info',
        windowClass: 'modalAlterado',
      }
    );
  } 

validaDataIncial(lista:any[]){
var operador = true;
  this.msgDtinicioInvalida = "Data de Início de Vigência não informada para o(s) município(s):";
  for (let i = 0; i < lista.length; i++) {
    const { start: mesInicio, end: mesFim, validacao:valida } = this.monthRangeFromMmYyyy(lista[i].dtIni, lista[i].dtFim);
    
    if(!valida){
      if(isNaN(mesInicio.getTime())){
      this.msgDtinicioInvalida += `\n• ${lista[i].Descricao}`;
      }
      if(mesFim!= null && isNaN(mesFim.getTime())){
        this.msgDtinicioInvalida = "Data de Fim de Vigência não informada para o(s) município(s):";
        this.msgDtinicioInvalida += `\n• ${lista[i].Descricao}`;
        lista[i].dtFim = null;
      }
      operador = false;
    }
  }
  return operador;
}

validarDtiniDtFim(lista:any[]){
  var operador = true;
  this.msgDtinicioInvalida = "Data de Fim de Vigência menor que Data de Início de Vigência para o(s) município(s):";
  for (let i = 0; i < lista.length; i++) {
    if(lista[i].dtFim){
        const { start: mesInicio, end: mesFim, validacao:valida } = this.monthRangeFromMmYyyy(lista[i].dtIni, lista[i].dtFim);
        const mesInicioTime = mesInicio.getTime();
        const mesFimTime = mesFim ? mesFim.getTime() : null;

      if(mesFimTime && mesInicioTime && mesFimTime < mesInicioTime){
        this.msgDtinicioInvalida += `\n• ${lista[i].Descricao}`;
        operador = false;
      }
    }
    
  }
  return operador;
}

excluir(modal:AslibModalService, item): void {
const options: IAslibModalOptions = {
      title: 'Exclusão de item',
      backdrop: 'static',
      text: `Confirma exclusão do registro atual?`,
      okText: 'Sim',
      cancelarText: 'Não',
      content: null,
      cancelarVisible: true
    };
    modal.open(options).result.then(
      () => {
        // Lógica para excluir o item
        this.listaMunicipios = this.listaMunicipios.filter(i => i !== item);
        this.listaMunicipios = [...this.listaMunicipios];
        console.log('Item excluído:', item);
      },
      () => {}
    );


}

irPraConsulta(){
   this.router.navigate(['/royalts/sarf-consulta-municipios-aptos']);
 }

 unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-municipios-aptos/cadastra-municipios-aptos.component.ts